import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/app/[locale]/(error)/404Client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/app/[locale]/PageContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DefaultLayout"] */ "/vercel/path0/apps/web/src/app/DefaultLayout.tsx");
